import {axiosi} from '../../config/axios'
import { collection, query, where, getDocs, getDoc , addDoc, Timestamp , doc, deleteDoc , updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

// export const createReview=async(review)=>{
//     try {
//         const res=await axiosi.post('/reviews',review)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const createReview = async (review) => {
    try {
      const docRef = await addDoc(collection(db, "reviews"), {
        user: review.user,
        product: review.product,
        rating: review.rating,
        comment: review.comment,
        createdAt: Timestamp.now(),
      });
  
      return {
        _id: docRef.id,
        ...review,
        createdAt: new Date().toISOString(),
      };
    } catch (error) {
      throw { message: error.message || "Failed to create review" };
    }
  };

// export const fetchReviewsByProductId=async(id)=>{
//     try {
//         const res=await axiosi.get(`/reviews/products/${id}`)
//         // return res.data
//     } catch (error) {
//         // throw error.response.data
//         return [
//             {
//                 "_id": "65c252e3dcd9253acfbaa76c",
//                 "user": {
//                     "_id": "65c2526fdcd9253acfbaa731",
//                     "name": "rishibakshi",
//                     "email": "demo2@gmail.com",
//                     "password": "$2a$10$tosjkprqtomSah0VJNyKi.TIv1JU65pl1i1IJ6wUttjYw.ENF99jG",
//                     "isVerified": true,
//                     "isAdmin": false,
//                     "__v": 0
//                 },
//                 "product": "65a7e45902e12c44f599444e",
//                 "rating": 5,
//                 "comment": "Exceeded expectations! This phone is a game-changer. Lightning fast, stunning camera, incredible battery life. Best phone ever! ",
//                 "createdAt": "2024-02-07T10:25:58.424Z"
//             },
//             {
//                 "_id": "65c25703dcd9253acfbaa970",
//                 "user": {
//                     "_id": "65b8e564ea5ce114184ccb96",
//                     "name": "demo user",
//                     "email": "demo@gmail.com",
//                     "password": "$2a$10$GH8p5cAsGFEdYsLaSfTQ3e1eUs7KbLmVBltjbX4DDCj2eyO2KW/Ze",
//                     "isVerified": true,
//                     "isAdmin": false,
//                     "__v": 0
//                 },
//                 "product": "65a7e45902e12c44f599444e",
//                 "rating": 5,
//                 "comment": "Great customer service! Quick and helpful in resolving a minor issue. Plus points for that!",
//                 "createdAt": "2024-02-07T10:25:58.424Z"
//             }
//         ]
//     }
// }

export const fetchReviewsByProductId = async (productId) => {
    try {
      // 1) Fetch all reviews for this product
      const q = query(
        collection(db, "reviews"),
        where("product", "==", productId)
      );
  
      const snap = await getDocs(q);
  
      if (snap.empty) return [];
  
      const reviews = [];
  
      for (const docSnap of snap.docs) {
        const reviewData = docSnap.data();
  
        // 2) Fetch user details
        const userRef = doc(db, "users", reviewData.user);
        const userSnap = await getDoc(userRef);
  
        reviews.push({
          _id: docSnap.id,
          ...reviewData,
          user: userSnap.exists()
            ? { _id: userSnap.id, ...userSnap.data() }
            : null,
        });
      }
  
      return reviews;
  
    } catch (error) {
      console.error(error);
  
      // fallback dummy data (same as you provided)
      return [
        {
          "_id": "65c252e3dcd9253acfbaa76c",
          "user": {
            "_id": "65c2526fdcd9253acfbaa731",
            "name": "rishibakshi",
            "email": "demo2@gmail.com",
            "password": "...",
            "isVerified": true,
            "isAdmin": false
          },
          "product": productId,
          "rating": 5,
          "comment":
            "Exceeded expectations! This phone is a game-changer. Lightning fast, stunning camera, incredible battery life. Best phone ever!",
          "createdAt": "2024-02-07T10:25:58.424Z"
        },
        {
          "_id": "65c25703dcd9253acfbaa970",
          "user": {
            "_id": "65b8e564ea5ce114184ccb96",
            "name": "demo user",
            "email": "demo@gmail.com",
            "...": "..."
          },
          "product": productId,
          "rating": 5,
          "comment":
            "Great customer service! Quick and helpful in resolving a minor issue. Plus points for that!",
          "createdAt": "2024-02-07T10:25:58.424Z"
        }
      ];
    }
  };
  

// export const updateReviewById=async(update)=>{
//     try {
//         const res=await axiosi.patch(`/reviews/${update._id}`,update)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const updateReviewById = async (update) => {
    try {
      const reviewRef = doc(db, "reviews", update._id);
  
      await updateDoc(reviewRef, {
        rating: update.rating,
        comment: update.comment,
        updatedAt: new Date(),
      });
  
      return { success: true, message: "Review updated successfully" };
    } catch (error) {
      throw { message: error.message || "Failed to update review" };
    }
  };

// export const deleteReviewById=async(id)=>{
//     try {
//         const res=await axiosi.delete(`/reviews/${id}`)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }

export const deleteReviewById = async (id) => {
    try {
      const reviewRef = doc(db, "reviews", id);
      await deleteDoc(reviewRef);
  
      return { success: true, message: "Review deleted successfully" };
    } catch (error) {
      throw { message: error.message || "Failed to delete review" };
    }
  };